<template>
  <div class="_pbs">
    <app-page-title :color="'lips'">
      <template #pageTitleLeft>
        <h1>
          <slot name="title">
            Add Primary Subscriber
          </slot>
        </h1>
      </template>
      <template #pageTitleRight>
        <slot name="buttons"></slot>
      </template>
    </app-page-title>
  </div>
</template>

<script>
  import AppPageTitle from '@sections/PageTitle'

  export default {
    components: {
      AppPageTitle
    },
    props: {
      step: {
        type: Number,
        default: 1
      },
      totalSteps: {
        type: Number,
        default: 3
      }
    }
  }
</script>
